<page-toolbar [pageActions]="pageActions" [title]="title"></page-toolbar>

<page-content>
  <data-table (detail)="onDetail($event)"
                  [columns]="columns"
                  [dataProvider]="organisationService"
                  [title]="title">
  </data-table>

</page-content>
